export const ADMIN_SCHOOL_AGODI_BRANCH_RESOURCE = {
  key: 'ADMIN_SCHOOL_AGODI_BRANCH_RESOURCE',
  single: {
    dataPath: 'result.spoEntityData.shadow',
    secondaryDataPath: 'result.spoEntityData.agodi',
    dataTransform: (i) => i
  },
  api: {
    getById: () => {
      throw new Error('replace api.getById for ADMIN_SCHOOL_AGODI_BRANCH_RESOURCE');
    }
  }
};
